import React from 'react';
import { Col, Row, Hidden } from 'react-grid-system';
import Icon from '@Components/Icon/Icon';
import { ICON_SIZE } from '../ShippingMethod';

const DesktopIcon = ({ name }: { name: types.iconNames }): JSX.Element => (
	<Hidden xs>
		<Col lg={1} md={1} sm={1}>
			<Row align="center" justify="center">
				<Icon testID={`desktop-${name}`} name={name} fill="black38" width={ICON_SIZE} height={ICON_SIZE} />
			</Row>
		</Col>
	</Hidden>
);

export default DesktopIcon;
